import { Resources } from 'constants/resources';

import EditIcon from '@mui/icons-material/Edit';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useShowController } from 'react-admin';
import { Link } from 'react-router-dom';
import { ContextMenu, ContextMenuButton } from 'shared/mui/ContextMenu';
import { TypographyTitle } from 'shared/mui/Typography';
import { FunctionField, OrderStatusChipField } from 'shared/react-admin/Fields';
import { Order } from 'types/embedded/order';
import { formatCurrency } from 'utils';

import { CardHeaderStyled, StyledBox } from './OrdersShowCommonInfoStateCardHeader.styled';

export const OrdersShowCommonInfoStateCardHeader = (): JSX.Element => {
  const translate = useTypedTranslate();
  const { createPathWithQuery } = useCreatePathWithQuery();

  const { record: order } = useShowController<Order>();

  return (
    <CardHeaderStyled>
      <StyledBox>
        <FunctionField
          render={(record: Order) => (
            <TypographyTitle size="small" sx={{ fontWeight: 500, mr: '8px' }}>
              {formatCurrency((record?.amount as Intl.StringNumericLiteral) || 0)}{' '}
              {record?.currency?.alphaCode}
            </TypographyTitle>
          )}
        />
        <FunctionField
          render={(record: Order) => (
            <RecordContextProvider value={record.status}>
              <OrderStatusChipField source="description" />
            </RecordContextProvider>
          )}
        />
      </StyledBox>
      <ContextMenu>
        <Link
          style={{
            textDecoration: 'none',
          }}
          target="_blank"
          to={createPathWithQuery(
            {
              resource: Resources.OrderAdjustments,
              type: 'list',
            },
            {
              filter: {
                id: [order?.originId],
              },
            },
          )}
        >
          <ContextMenuButton
            icon={<EditIcon fontSize="small" />}
            label={translate('app.orders.orderAdjustment')}
          />
        </Link>
      </ContextMenu>
    </CardHeaderStyled>
  );
};
